import { render, staticRenderFns } from "./TextClicker.vue?vue&type=template&id=387dc0dc&"
import script from "./TextClicker.vue?vue&type=script&lang=js&"
export * from "./TextClicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports